<template>
	<div v-if="isErrorForm" class="errors">
		<span class="perr">{{errorForm}}</span>
	</div>
	<table class="form">
		<tbody class="first-body last-body">
		<tr><td>
			<span style="white-space: nowrap" v-html="campaignTitle"></span>
			&nbsp;
			<select v-model.number="campaign">
			  <option value="0">-</option>
			  <option v-for="item in campaignList" :value="item.id">
				{{ item.name }}
			  </option>
			</select>
			&nbsp;
			<button class="button" @click="addToCampaign" :disabled='disabledButton'>
				{{buttonTitle}}
			</button>
			<span v-if="isErrorProperty" class="perr">{{errorProperty}}</span>
		</td></tr>
		</tbody>
	</table>
</template>

<script setup lang="ts">
	import { ref, computed, onMounted } from 'vue';
	import {injectEnv} from "@fd/Environment.ts";

	const props = defineProps<{
		party: number,
		buttonTitle: string,
		campaignTitle: string,
		emptyTitle: string
	}>();

	const emit = defineEmits(['refresh']);
	const env = injectEnv();

	const campaign = ref(0);
	const errorForm = ref("");
	const errorProperty = ref("");

	interface CampaignIdName {
		id: number,
		name: string
	}

	const campaignList = ref<CampaignIdName[]>([]);

	const disabledButton = computed(() => {
		return campaignList.value.length === 0;
	});

	const isErrorForm = computed(() => {
		return !!errorForm.value;
	});

	const isErrorProperty = computed(() => {
		return !!errorProperty.value;
	});

	async function addToCampaign(): Promise<void> {
		errorForm.value = "";
		if (campaign.value === 0) {
			errorProperty.value = props.emptyTitle ?? "";
		} else {
			errorProperty.value = "";
			const data = {
				"campaign": campaign.value,
				"party": props.party
			};
			try {
				const nr = await env.net.fetch("api/campaignparties", "POST", data);
				if (nr.ok) {
					removeFromList(campaign.value);
					campaign.value = 0;
					emit('refresh');
				} else {
					console.error('Error:', nr.status);
					errorForm.value = "RestApi point return status:" + nr.status;
				}
			} catch (e) {
				console.error('Error:', e);
				errorForm.value = "Error to fetch restApi point";
			}
		}
	}

	async function loadData(): Promise<void> {
		campaignList.value = [];
		let ep: string = "api/campaigns/enterable";
		ep = env.net.urlParam(ep, "party", props.party);
		try {
			const nr = await env.net.fetch(ep)
			if (nr.ok) {
				campaignList.value = await nr.json() as CampaignIdName[];
			} else {
				errorForm.value = "RestApi point return status:" + nr.status;
			}
		} catch (error) {
			console.log("Error loading campaign list:" + error);
			errorForm.value = error;
		}
	}

	function removeFromList(campaignId: number): void {
		campaignList.value = campaignList.value.filter(item => item.id !== campaignId);
	}

	onMounted(() => {
		loadData();
	});
</script>
